import React from 'react';
import { DesignSystemShadowProvider } from './DesignSystemShadowProvider';
import { RegionCurrencyContextProvider, WishlistCustomerKeyProvider } from '@skin-seoul/service';
import { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider } from '@tanstack/react-query';

type WishlistCustomerKeyProviderProps = {
  children?: React.ReactNode;
};
const queryClient = new QueryClient();

const ShortcodeProvider = ({ children }: WishlistCustomerKeyProviderProps) => {
  return (
    <DesignSystemShadowProvider>
      <QueryClientProvider client={queryClient}>
        <RegionCurrencyContextProvider>
          <WishlistCustomerKeyProvider>{children}</WishlistCustomerKeyProvider>
        </RegionCurrencyContextProvider>
      </QueryClientProvider>
    </DesignSystemShadowProvider>
  );
};

export default ShortcodeProvider;
